export default __webpack_public_path__ + "static/media/juego28_sinexito.35087fd3.png";